/**
 * Author：Qian.qianchen 2019-11-04
 * discription: 产品管理 微博 微博账号排序
 */
"use strict";
angular.module("productManageMentSortToutiaohaoModule", [])
    .controller('productManageMentSortToutiaohaoCtrl', ['$scope', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$validation', function($scope, $modalInstance, modalDialog, item, trsHttpService, $validation) {
        initStatus();

        function initStatus() {
            $scope.data = {
                userName: item.TITLE,
                indexNum: item.index,
                userId: item.TOUTIAOCHANNELID
            }
        }
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.sortForm.$pending = {};
            $validation.validate($scope.sortForm).success(function() {
                var params = {
                    serviceid: "mlf_toutiaoconfig",
                    methodname: "resetOrder",
                    TouTiaoChannelId: $scope.data.userId,
                    order: $scope.data.indexNum
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post',true).then(function(data) {
                    $modalInstance.close("success");
                }, function(data) {
                    $modalInstance.close(data);
                });
            });
        };
    }]);